import { Component, ViewChild, OnInit, HostListener } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { ConstantsService } from '../common/services/constants.service';
declare var Razorpay: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './buyexam.component.html',
  styleUrls: ['./dashboard.component.css']
})


export class BuyexamComponent implements OnInit {

  public alertOption: SweetAlertOptions = {};  
  @ViewChild('msgSwal') private msgSwal: SwalComponent;

  couponFormControl = new FormControl('', [
      Validators.required,
      Validators.minLength(4),
  ]);

  title = 'Pareekshn';
  selectedValue: any = 'topic';
  userinfo: any;
  studentid: number = 0;
  isErrorUsername: boolean;
  errorMsg: any;
  loading: boolean;
  examdata: any;
  isValid = true;
  usertoken: string;
  exam_id: number = 0;
  self_studentid: number = 0;
  returnUrl : string;
  name: string;
  email: string;
  phone;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private http: HttpClient
  ) { }

    options = {
    "key": "",
    "amount": 0, 
    "name": "Pareekshn Skill",
    "description": "Payment of paid examination",
    "image": "https://www.pareekshn.com/assets/images/logo.png",
    "order_id":"",
    "handler": function (response){
        var event = new CustomEvent("payment.success", 
            {
                detail: response,
                bubbles: true,
                cancelable: true
            }
        );    
        window.dispatchEvent(event);
    }
    ,
    "prefill": {
    "name": "",
    "email": "",
    "contact": ""
    },
    "notes": {
    "address": ""
    },
    "theme": {
    "color": "#3399cc"
    }
    };

  ngOnInit() {

    var step = this.route.snapshot.paramMap.get("step");
    this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); //console.log(this.userinfo);
    this.studentid = this.userinfo['student_id'];
    this.name = this.userinfo['name'];
    this.email = this.userinfo['email'];
    this.phone = this.userinfo['mobile'];
    this.usertoken = this.userinfo['usertoken'];

    if(step == null)
    {
      this.returnUrl = '/dashboard';    
    }
    else{
      //this.exam_id_result = parseInt(step);   
      var IDs = step.split('@');
      this.exam_id = parseInt(IDs[0]);    
      this.self_studentid = parseInt(IDs[1]);    
    }
    
    if(this.self_studentid > 0 && this.exam_id > 0)   
    {
      this.fetchPaidExamDetails(); 
    }
  }

exam_info;
examsdata = []; 
examfeeArr = {};
exam_fee;
taxamount;
totalfee;
totaltax;
taxv:number = 0;
taxArr = [];
taxjson = [];
fetchPaidExamDetails()
{ 
  this.loading = true;
  this.spinner.show();
    this.authenticationService.getPaidExamDetails(this.globals.root_url, this.self_studentid, this.usertoken, this.exam_id)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.exam_info = data.exam_detail;  console.log(this.exam_info);   
              if(this.exam_info.exam_fee != undefined)
              {
                this.examfeeArr = this.exam_info.exam_fee;  
                this.exam_fee = this.examfeeArr['exam_fee'];              
              }  
              let taxv = 0;
              if(this.exam_info.tax != undefined)
              {
                this.taxArr = this.exam_info.tax;                
              } 
              for(var i =0; i < this.taxArr.length; ++i)
              {
                taxv = taxv + this.taxArr[i].tax_value;
                this.taxjson[i] = { tax_name: this.taxArr[i].tax_name, tax_value: this.taxArr[i].tax_value }; 
              }
              this.totaltax = taxv;
              this.taxamount = (this.examfeeArr['exam_fee'] * taxv)/100;
              this.totalfee =  this.taxamount + this.exam_fee;                                          
              this.loading = false;
              this.spinner.hide();
          }
          else {
            this.errorMsg = data.status;
            this.loading = false;
            this.spinner.hide();
          }          
        },
        error => {
          this.errorMsg = 'No Result Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
 }

  formatDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
  }
  convertStoMs(seconds) {
     let minutes = ~~(seconds / 60);
     let extraSeconds = seconds % 60;
     return minutes + " Min " + extraSeconds + " Seconds";
  } 
 goDashboard()
 {
  this.router.navigateByUrl('/dashboard'); 
 }
isErrorLogin = false; 
discount;
promocode = '';
promoid: number = 0;
discountvalue: number = 0;
applyCoupon()
{ 
  if (this.couponFormControl.valid == false) {
      this.isErrorLogin = true;
      return false;
  }
  else
  {
    this.loading = true;
    this.spinner.show();
    this.authenticationService.applycoupon(this.globals.root_url, this.self_studentid, this.usertoken, this.couponFormControl.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
              this.discount = data.promo.discount_percentage;
              this.promocode = data.promo.promo_code;
              this.promoid = data.promo.id;
              this.discountvalue = (this.exam_fee * this.discount)/100
              this.totalfee =  this.totalfee - this.discountvalue;                                         
              this.loading = false;
              this.spinner.hide();
          }
          else {
            this.isErrorLogin = true;
            this.errorMsg = data.status;
            this.loading = false;
            this.spinner.hide();
          }          
        },
        error => {
          this.errorMsg = 'No Result Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );    
  } 

 }  
  paymentId: string;
  error: string;
  id_student_payments: number = 0;
  razorpay_payment_id: string = '';
  payfee()
  {
    this.paymentId = ''; 
    this.error = ''; 
    this.loading = true;
    this.spinner.show();    
    this.authenticationService.createOrder(this.globals.root_url, this.usertoken, this.self_studentid, this.exam_id, this.promoid).subscribe(
    data => {
          if (data.code == 1000) { 
            this.options.key = ConstantsService.ROZARPAY_KEY;
            this.options.order_id = data.payment_detail.id;
            this.options.amount = (this.totalfee)*100; //paise
            this.options.prefill.name = this.name;
            this.options.prefill.email = this.email;
            this.options.prefill.contact = this.phone;
            var rzp1 = new Razorpay(this.options);
            rzp1.open();
                       
            rzp1.on('payment.failed', function (response){    
                // Todo - store this information in the server
                console.log(response.error.code);    
                console.log(response.error.description);    
                console.log(response.error.source);    
                console.log(response.error.step);    
                console.log(response.error.reason);    
                console.log(response.error.metadata.order_id);    
                console.log(response.error.metadata.payment_id);
                this.error = response.error.reason;
            }
            );   
              this.id_student_payments = data.payment_detail.id_student_payments;                                   
              this.razorpay_payment_id = data.payment_detail.id;                                   
              this.loading = false;
              this.spinner.hide();
          }
          else {
            //this.isErrorLogin = true;
            this.errorMsg = data.status;
            this.loading = false;
            this.spinner.hide();
          }       

    }
    ,
    err => {
        this.errorMsg = err.error.message;
        this.loading = false;
        this.spinner.hide();     
    }
    );    
  }
  referenceId;
  payment_mode;
  amount_paid;
  @HostListener('window:payment.success', ['$event']) 
  onPaymentSuccess(event): void { 
      this.loading = true;
      this.spinner.show();  
      this.authenticationService.updateOrder(this.globals.root_url, this.usertoken, this.self_studentid, this.exam_id, this.id_student_payments, event.detail.razorpay_payment_id).subscribe(
      data => {
        if (data.code == 1000) {     
          this.paymentId = event.detail.razorpay_payment_id;
          //this.referenceId = data.pay_detail.reference_id;
          //this.payment_mode = data.pay_detail.payment_mode;
          //this.amount_paid = data.pay_detail.amount_paid;
          this.loading = false;
          this.spinner.hide();             
          this.msgSwal.show();      
          this.goDashboard();    
        }
      }
      ,
      err => {
          this.error = err.error.message;
          this.loading = false;
          this.spinner.hide();          
      }
      );
  }  
}





